import styled from 'styled-components';

export const Content = styled.div`
  & .payment-form {
    width: 100%;
  }

  & .payment-form > div {
    width: 100%;
  }

  & h4 {
    font-weight: 600;
    font-size: 26px;
    line-height: 130%;
    color: var(--color-fixed-brand);
    margin: 0;
    text-align: center;
    margin-bottom: 20px;
  }

  & .checkBoxWrapper {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 11px;
    line-height: 100%;
    color: var(--color-text-muted);
    margin-bottom: 20px;

    & a {
      padding-left: 1px;
      padding-right: 1px;
      color: var(--color-link);
      text-decoration: none;
      transition: color 0.15s ease;

      &:hover {
        color: var(--color-title);
        text-decoration: underline;
      }
    }
  }

  & .buttonWrapper {
    display: flex;
    justify-content: space-evenly;
    grid-gap: 20px;
  }

  & .card-number-input {
    margin-bottom: 20px;
  }

  & .flex50percents {
    display: flex;
    width: 100%;
    grid-gap: 10px;
    margin-bottom: 20px;

    & > * {
      flex: 1 1 calc(50% - 5px);
      min-width: 0;
      width: 100%;
    }
  }

  & .iconsWrapper {
    display: flex;
    grid-gap: 20px;
    margin-bottom: 20px;
    justify-content: space-between;
  }
`;
